import { CurrentFlow } from 'enums/CurrentFlow';

export const FLOW_ARG_TO_CURRENT_FLOW: Record<string, CurrentFlow> = {
  card: CurrentFlow.Card,
  student: CurrentFlow.StudentLoanForgiveness,
  lending: CurrentFlow.DebtConsolidation,
  'ai-coach': CurrentFlow.AICoach,
};
